"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var DOM_HTML_Indexed_InputType = require("../DOM.HTML.Indexed.InputType/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Data_Void = require("../Data.Void/index.js");
var Effect = require("../Effect/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Halogen_Aff_Util = require("../Halogen.Aff.Util/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Halogen_VDom_Driver = require("../Halogen.VDom.Driver/index.js");
var Haskell_Parser = require("../Haskell.Parser/index.js");
var Haskell_PostParser = require("../Haskell.PostParser/index.js");
var Haskell_Render = require("../Haskell.Render/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_HTMLTextAreaElement = require("../Web.HTML.HTMLTextAreaElement/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var Web_Storage_Storage = require("../Web.Storage.Storage/index.js");
var Initial = (function () {
    function Initial() {

    };
    Initial.value = new Initial();
    return Initial;
})();
var PushButton = (function () {
    function PushButton() {

    };
    PushButton.value = new PushButton();
    return PushButton;
})();
var ClearCache = (function () {
    function ClearCache() {

    };
    ClearCache.value = new ClearCache();
    return ClearCache;
})();
var Refresh = (function () {
    function Refresh(value0) {
        this.value0 = value0;
    };
    Refresh.create = function (value0) {
        return new Refresh(value0);
    };
    return Refresh;
})();
var SubAction = (function () {
    function SubAction(value0) {
        this.value0 = value0;
    };
    SubAction.create = function (value0) {
        return new SubAction(value0);
    };
    return SubAction;
})();
var textBox = "text-box";
var rex = function (s) {
    if (s.ast instanceof Haskell_Parser.ParseError) {
        return {
            ast: Halogen_HTML_Core.text("PARSE ERROR"),
            summary: [  ]
        };
    };
    if (s.ast instanceof Haskell_Parser.Ok) {
        var v = Haskell_Render.runRenderM(s.focus)(Haskell_Render.render(Haskell_Render.renderWhole(Haskell_Render.renderModule))(Haskell_PostParser.postParse(Haskell_PostParser.postParseWhole(Haskell_PostParser.postParseModule))(s.ast.value0.result)));
        return {
            ast: Data_Bifunctor.bimap(Halogen_HTML_Core.bifunctorHTML)(Data_Void.absurd)(SubAction.create)(v.ast),
            summary: Data_Functor.map(Data_Functor.functorArray)(Data_Bifunctor.bimap(Halogen_HTML_Core.bifunctorHTML)(Data_Void.absurd)(SubAction.create))(v.summary)
        };
    };
    throw new Error("Failed pattern match at Main (line 64, column 9 - line 70, column 6): " + [ s.ast.constructor.name ]);
};
var getRefValue = function (dictMonadEffect) {
    return function (r) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.getRef(r))(function (e$prime) {
            return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))((function () {
                var v = Control_Bind.bind(Data_Maybe.bindMaybe)(e$prime)(Web_HTML_HTMLTextAreaElement.fromElement);
                if (v instanceof Data_Maybe.Nothing) {
                    return Effect_Exception["throw"]("Should not happen");
                };
                if (v instanceof Data_Maybe.Just) {
                    return Web_HTML_HTMLTextAreaElement.value(v.value0);
                };
                throw new Error("Failed pattern match at Main (line 149, column 14 - line 151, column 25): " + [ v.constructor.name ]);
            })());
        });
    };
};
var example = "-- Example\x0amodule Main (main) where\x0a\x0aimport System.IO (print)\x0a\x0adrop :: Int -> [a] -> [a]\x0adrop 0 xs = xs\x0adrop n [] = []\x0adrop n (x : xs) = drop (n-1) xs\x0a\x0afilterMap :: (a -> Maybe b) -> [a] -> [b]\x0afilterMap f [] = []\x0afilterMap f (x : xs) = case f x of\x0a  Just y -> y : filterMap f xs\x0a  Nothing -> filterMap f xs\x0a\x0atraverse :: {- contexts TODO -} (a -> f b) -> [a] -> f [b]\x0atraverse f [] = pure []\x0atraverse f (x : xs) = do\x0a  y <- f x\x0a  ys <- traverse f xs\x0a  pure (y : ys)\x0a\x0alast :: [a] -> a\x0alast (x : xs@(_ : _)) = last xs\x0alast [x] = x\x0a\x0amain :: IO ()\x0amain = do\x0a  print (last [1,2,3])\x0a  traverse print (filterMap Just ['a', 'b', 'c'])\x0a  pure ()\x0a";
var inputComponent = function (dictMonadEffect) {
    var render = function (s) {
        return Halogen_HTML_Elements.div([ Haskell_Render.classes([ "app-ui-panel", "flex-1", "flexbox-v", "app-input" ]) ])([ Halogen_HTML_Elements.div([ Haskell_Render.classes([ "flexbox-h", "flex-0" ]) ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v) {
            return PushButton.value;
        }), Haskell_Render.classes([ "flex-1" ]) ])([ Halogen_HTML_Core.text("Parse!") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(function (v) {
            return ClearCache.value;
        }), Haskell_Render.classes([ "flex-1" ]) ])([ Halogen_HTML_Core.text("Clear cache") ]) ]), Halogen_HTML_Elements.div([ Haskell_Render.classes([ "flex-1", "box" ]) ])([ Halogen_HTML_Elements.textarea([ Halogen_HTML_Properties.ref(textBox), Halogen_HTML_Properties.value(s), Halogen_HTML_Properties.spellcheck(false) ]) ]) ]);
    };
    var initialState = function (v) {
        return "";
    };
    var handleAction = function (a) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.localStorage)(Web_HTML.window)))(function (store) {
            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)((function () {
                if (a instanceof Initial) {
                    return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(function __do() {
                        var v = Web_Storage_Storage.getItem("value")(store)();
                        if (v instanceof Data_Maybe.Just) {
                            return v.value0;
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return example;
                        };
                        throw new Error("Failed pattern match at Main (line 178, column 40 - line 180, column 36): " + [ v.constructor.name ]);
                    });
                };
                if (a instanceof PushButton) {
                    return getRefValue(dictMonadEffect)(textBox);
                };
                if (a instanceof ClearCache) {
                    return Control_Apply.applySecond(Halogen_Query_HalogenM.applyHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Web_Storage_Storage.clear(store)))(Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(example));
                };
                throw new Error("Failed pattern match at Main (line 176, column 12 - line 182, column 66): " + [ a.constructor.name ]);
            })())(function (s) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Web_Storage_Storage.setItem("value")(s)(store)))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v) {
                        return s;
                    }))(function () {
                        return Halogen_Query_HalogenM.raise(s);
                    });
                });
            });
        });
    };
    return Halogen_Component.mkComponent({
        initialState: initialState,
        render: render,
        "eval": Halogen_Component.mkEval({
            handleAction: handleAction,
            handleQuery: Halogen_Component.defaultEval.handleQuery,
            receive: Halogen_Component.defaultEval.receive,
            initialize: new Data_Maybe.Just(Initial.value),
            finalize: Halogen_Component.defaultEval.finalize
        })
    });
};
var component = function (dictMonadEffect) {
    var rightPanel = function (focus) {
        return function (summary) {
            return Halogen_HTML_Elements.div([ Haskell_Render.classes([ "app-ui-rightpanel", "flex-1", "flexbox-v" ]) ])([ Halogen_HTML_Elements.div([ Haskell_Render.classes([ "title", "flex-0" ]) ])([ Halogen_HTML_Elements.h1_([ Halogen_HTML_Core.text("The Haskell Syntaxonomer") ]) ]), Halogen_HTML_Elements.div([ Haskell_Render.classes([ "flex-0", "box" ]) ])([ Halogen_HTML_Elements.div([ Haskell_Render.classes([ "app-options" ]) ])([ Halogen_HTML_Elements.label([ Halogen_HTML_Properties["for"]("show-layout") ])([ Halogen_HTML_Elements.span([ Haskell_Render.classes([ "yes" ]) ])([ Halogen_HTML_Core.text("Show") ]), Halogen_HTML_Core.text("/"), Halogen_HTML_Elements.span([ Haskell_Render.classes([ "no" ]) ])([ Halogen_HTML_Core.text("Hide") ]), Halogen_HTML_Core.text(" layout tokens") ]) ]) ]), Halogen_HTML_Elements.div([ Haskell_Render.classes([ "flex-1", "box" ]) ])([ Haskell_Render.info(focus) ]), Halogen_HTML_Elements.div([ Haskell_Render.classes([ "flex-5" ]) ])([ Halogen_HTML_Elements.div([ Haskell_Render.classes([ "ast-path", "panel" ]) ])(summary) ]) ]);
        };
    };
    var leftPanel = function (ast) {
        return Halogen_HTML_Elements.div([ Haskell_Render.classes([ "app-ui-leftpanel", "flex-1", "flexbox-v" ]) ])([ Halogen_HTML_Elements.div([ Haskell_Render.classes([ "flex-0", "box", "tooltip" ]) ])([ Halogen_HTML_Core.text("Click on an element to see syntax information on the right panel.") ]), Halogen_HTML_Elements.div([ Haskell_Render.classes([ "flex-1", "box", "panel" ]) ])([ Halogen_HTML_Elements.div([ Haskell_Render.classes([ "app-output" ]) ])([ ast ]) ]), Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
            return "input";
        }))(Data_Ord.ordUnit)(Type_Proxy["Proxy"].value)(Data_Unit.unit)(inputComponent(dictMonadEffect))(Data_Unit.unit)(Refresh.create) ]);
    };
    var render = function (s) {
        var v = rex(s);
        return Halogen_HTML_Elements.div([ Haskell_Render.classes([ "app" ]) ])([ Halogen_HTML_Elements.input([ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.id("show-layout") ]), Halogen_HTML_Elements.div([ Haskell_Render.classes([ "app-ui", "flexbox-h" ]) ])([ leftPanel(v.ast), rightPanel(s.focus)(v.summary) ]) ]);
    };
    var initialState = function (v) {
        return {
            ast: Haskell_Parser.ParseError.value,
            focus: Haskell_Render.Idle.value
        };
    };
    var handleSubAction = function (a) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (s) {
            var v = Haskell_Render.handleAction(a)(s.focus);
            if (v instanceof Data_Maybe.Nothing) {
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
            };
            if (v instanceof Data_Maybe.Just) {
                return Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                    var $34 = {};
                    for (var $35 in s) {
                        if ({}.hasOwnProperty.call(s, $35)) {
                            $34[$35] = s[$35];
                        };
                    };
                    $34.focus = v.value0;
                    return $34;
                })());
            };
            throw new Error("Failed pattern match at Main (line 141, column 39 - line 143, column 38): " + [ v.constructor.name ]);
        });
    };
    var handleAction = function (v) {
        if (v instanceof Refresh) {
            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect))(Haskell_Parser.parse(v.value0)))(function (ast) {
                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                    return {
                        ast: ast,
                        focus: Haskell_Render.Idle.value
                    };
                });
            });
        };
        if (v instanceof SubAction) {
            return handleSubAction(v.value0);
        };
        throw new Error("Failed pattern match at Main (line 135, column 18 - line 139, column 37): " + [ v.constructor.name ]);
    };
    return Halogen_Component.mkComponent({
        initialState: initialState,
        render: render,
        "eval": Halogen_Component.mkEval({
            handleAction: handleAction,
            handleQuery: Halogen_Component.defaultEval.handleQuery,
            receive: Halogen_Component.defaultEval.receive,
            initialize: Halogen_Component.defaultEval.initialize,
            finalize: Halogen_Component.defaultEval.finalize
        })
    });
};
var main = Halogen_Aff_Util.runHalogenAff(Control_Bind.bind(Effect_Aff.bindAff)(Halogen_Aff_Util.awaitBody)(function (body) {
    return Halogen_VDom_Driver.runUI(component(Effect_Aff.monadEffectAff))(Data_Unit.unit)(body);
}));
module.exports = {
    example: example,
    rex: rex,
    main: main,
    textBox: textBox,
    Refresh: Refresh,
    SubAction: SubAction,
    component: component,
    getRefValue: getRefValue,
    Initial: Initial,
    PushButton: PushButton,
    ClearCache: ClearCache,
    inputComponent: inputComponent
};
